import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[crm-board-card-content], [crmBoardCardContent]',

})
export class CrmBoardCardContentDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
